<template>
    <div class="select-box">
        <div class="select-box-current" v-ripple @click="toggleSelectBox">
            <span>{{ this.selectedItem ? this.selectedItem.text : '' }}</span>
            <i class="fa" :class="{ 'fa-chevron-down': !open, 'fa-chevron-up': open }"></i>
        </div>
        <div class="select-box-open" :class="{ open }">
            <div class="select-box-separator"></div>
            <div class="select-box-items">
                <div class="select-box-item" v-for="item in items" :key="item.value" @click="selectItem(item)" v-ripple>
                    <i class="fa fa-check" :class="{ visible: selectedValue === item.value }"></i>
                    <span>{{ item.text }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        value: {},
    },
    watch: {
        value() {
            this.setDefaultSelectedValue();
        },
    },
    computed: {
        selectedItem() {
            return this.items.find(item => item.value === this.selectedValue);
        },
    },
    data() {
        return {
            selectedValue: null,
            open: false,
        };
    },
    created() {
        this.setDefaultSelectedValue();
    },
    methods: {
        setDefaultSelectedValue() {
            if (this.items.length === 0) {
                this.selectedValue = null;
            } else {
                this.selectedValue = this.value || this.items[0].value;
            }
        },
        selectItem(item) {
            this.selectedValue = item.value;
            this.open = false;

            this.$emit('input', this.selectedValue);
        },
        toggleSelectBox() {
            this.open = !this.open;
        },
    },
};

</script>

<style lang="scss">
    @import '../../style/common/SelectBox.scss';
</style>
